import { DATE_FORMAT } from '@/main.config'

export const nowMoment = {
  computed: {
    nowMoment() {
      return this.moment().utc()
    },
    nowLocal() {
      return this.moment().local()
    },
    nowFormatRu() {
      return this.nowMoment.format(DATE_FORMAT.ru)
    },
    nowFormatServer() {
      return this.nowMoment.format(DATE_FORMAT.server)
    }
  }
}
